import React from "react";

import ListingDraftHeader from "../header/ListingDraftHeader";
import ListingPreviewTable from "../../details/preview/ListingPreviewTable";

import s from "./ListingDraftPreview.module.scss";

export default function ListingDraftPreview({ product, goBack = () => {} }) {
	return (
		<div className={s.root}>
			<ListingDraftHeader listing={product} goBack={goBack} />

			<div className={s.pageContent}>
				<ListingPreviewTable product={product} />
			</div>
		</div>
	);
}
